import PlacesExploreClient from './PlacesExploreClient';

let service: PlacesExploreClient | undefined;

export default function getPlacesService(): PlacesExploreClient {
    if (service === undefined) {
        service = new PlacesExploreClient();
    }
    return service;
}
